import AppLoading from 'expo-app-loading';
import { StatusBar } from 'expo-status-bar';
import React from 'react';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import SoundsContext from './contexts/SoundsContext';
import useSounds from './hooks/useSounds';
import HomeScreen from './screens/HomeScreen';
import store from './store/redux';

const App: React.VFC = () => {
	const sounds = useSounds();

	if (!sounds.isReady) {
		return <AppLoading />;
	}
	return (
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistStore(store)}>
				<StatusBar hidden />
				<SoundsContext.Provider value={sounds}>
					<HomeScreen />
				</SoundsContext.Provider>
			</PersistGate>
		</Provider>
	);
};

export default App;
